import React from "react";
import { Typography } from "@mui/material";
import MuiCard from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { makeStyles } from "tss-react/mui";
import { LocalizedText } from "../i18n/LocalizedText.js";
const useStyles = makeStyles()((theme) => ({
  cardContainer: {
    width: "max-content",
    borderRadius: theme.custom.defaultBorderRadius * 2
  },
  cardContainerFullWidth: {
    width: "100%"
  },
  whiteBackground: {
    backgroundColor: theme.palette.background.paper
  },
  grayBackground: {
    backgroundColor: theme.palette.background.default
  },
  largeSpacing: {
    padding: `${theme.spacing(3)} !important`
  },
  mediumSpacing: {
    padding: `${theme.spacing(2)} !important`
  },
  smallSpacing: {
    padding: `${theme.spacing(0.5)} !important`
  },
  titleSpacing: {
    marginBottom: theme.spacing(2)
  }
}));
function Card({
  title,
  children,
  className,
  variant = "h6",
  styledContent = true,
  titleClassName,
  background = "white",
  spacing = "large",
  width = "auto",
  hasTitleSpacing = false
}) {
  const { classes, cx } = useStyles();
  const spacingClasses = {
    large: classes.largeSpacing,
    medium: classes.mediumSpacing,
    small: classes.smallSpacing
  };
  const spacingClass = spacingClasses[spacing];
  return /* @__PURE__ */ React.createElement(
    MuiCard,
    {
      className: cx(classes.cardContainer, className, background === "white" ? classes.whiteBackground : classes.grayBackground, {
        [classes.cardContainerFullWidth]: width === "full"
      })
    },
    /* @__PURE__ */ React.createElement(CardContent, { className: cx(styledContent && spacingClass) }, /* @__PURE__ */ React.createElement(Typography, { variant, className: cx(titleClassName, { [classes.titleSpacing]: hasTitleSpacing }) }, /* @__PURE__ */ React.createElement(LocalizedText, { label: title })), children)
  );
}
export {
  Card
};
//# sourceMappingURL=Card.js.map
